export const ACTIONS = {
  REQUEST_NOT_NEEDED: 'REQUEST_NOT_NEEDED',
}

export const requestNotNeeded = {
  type: ACTIONS.REQUEST_NOT_NEEDED,
}
